(function(global) {
	'use strict';
	
	/* アイソカル common.js (実行は各ページ専用 script.jp にて) */
	
	window.ISCL = window.ISCL || {};
	const ISCL = window.ISCL;
	
	ISCL.onLoaded = function(fns) {
		const setFns = [
			webFontLoader,
			improvementSource,
			drawerMenu,
			setupModalContents /* (= modalContentsUi, setInview (= pulldownUi), anchorScroll) */
		];
		if (fns !== undefined && fns !== null) {
			for (let i = 0, len = fns.length; i < len; i++) {
				if (typeof fns[i] === 'function') {
					setFns.push(fns[i]);
				}
			}
		}
		addFnc(setFns);
	}
	ISCL.onResize = function(fn) {
		resized(function() {
			if (typeof as.startPos === 'function') as.onResize();
			if (typeof pd.pullData === 'function') pd.refresh();
			if (typeof fn === 'function') fn();
		});
	}
	
	/**
	 * Lighthouse Report に基づく修正
	 -------------------------------------------------- */
	function improvementSource() {
		isrc.constructor();
	}
	const isrc = {
		constructor: function() {
			if (document.querySelector('a[target]:not([rel])') !== null) this.forBestPractices();
		},
		forBestPractices: function() {
			const blankLinks = document.querySelectorAll('a[target]:not([rel])');
			for (let i = blankLinks.length; i--;) {
				blankLinks[i].setAttribute('rel', 'noopener');
				
			}
		}
	}
	
	/**
	 * Web Font Loader
	 -------------------------------------------------- */
	function webFontLoader() {
		// console.log('-----> webFontLoader');
		wf.constructor();
	}
	const wf = {
		constructor: function() {
			window.WebFontConfig = {
				custom: {
					families: [ 'Noto Sans JP', 'M PLUS 1p' ],
					urls: [ 'https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500;800;900&family=Noto+Sans+JP:wght@400;500;700;900&display=swap&subset=japanese' ]
				},
				loading: function() {
					//console.log('loading');
					// isocal/recipe ページ用のプルダウン UI があったらフォント読み込み後に refresh()
					if (ISCL.pd !== undefined) ISCL.pd.refresh();
				},
				active: function() {
					//console.log('active');
					sessionStorage.fonts = true;
				}
			};
			this.setup(document);
		},
		setup: function(d) {
			const wf = d.createElement('script'), s = d.scripts[0];
			wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
			wf.defer = true;
			s.parentNode.insertBefore(wf, s);
		}
	};
	
	/**
	 * .js-navTrigger クリックで .l-nav を開閉
	 * dm.closeMenu();
	 -------------------------------------------------- */
	function drawerMenu() {
		if (document.querySelector('.js-navTrigger') !== null) {
			//console.log('-----> drawerMenu');
			dm.constructor();
		}
	}
	const dm = {
		constructor: function() {
			this.yOffset = window.pageYOffset;
			this.menu = document.getElementsByClassName('l-nav')[0];
			this.btn = document.getElementsByClassName('js-navTrigger');
			for (let i = this.btn.length; i--;) {
				this.btn[i].addEventListener('click', this.toggleMenu);
				this.btn[i].addEventListener('transitionend', this.btnEnd);
				this.btn[i].setAttribute('aria-label', 'メニューを開く');
				if (!ISCL.isDesktop) {
					this.btn[i].setAttribute('aria-expanded', false);
				}
			}
			if (!ISCL.isDesktop) {
				this.menu.setAttribute('aria-hidden', true);
			}
			this.menu.addEventListener('transitionend', this.menuEnd);
		},
		toggleMenu: function() {
			!dm.isOpened ? dm.openMenu() : dm.closeMenu();
		},
		openMenu: function() {
			dm.isOpened = true;
			dm.yOffset = window.pageYOffset;
			//console.log('openMenu', dm.yOffset);
			document.body.classList.add('is-fixed');
			document.body.style.marginTop = -dm.yOffset + 'px';
			
			dm.menu.classList.add('is-anim');
			dm.menu.classList.add('is-active');
			if (!ISCL.isDesktop) {
				dm.menu.setAttribute('aria-hidden', false);
			}
			for (let i = dm.btn.length; i--;) {
				dm.btn[i].classList.add('is-anim');
				dm.btn[i].classList.add('is-active');
				dm.btn[i].setAttribute('aria-label', 'メニューを閉じる');
				if (!ISCL.isDesktop) {
					dm.btn[i].setAttribute('aria-expanded', true);
				}
			}
		},
		closeMenu: function() {
			//console.log('closeMenu', dm.yOffset);
			document.body.classList.remove('is-fixed');
			document.body.removeAttribute('style');
			window.scrollTo(0, dm.yOffset);
			dm.isOpened = false;
			
			dm.menu.classList.add('is-anim');
			dm.menu.classList.remove('is-active');
			if (!ISCL.isDesktop) {
				dm.menu.setAttribute('aria-hidden', true);
			}
			for (let i = 0, len = dm.btn.length; i < len; i++) {
				dm.btn[i].classList.add('is-anim');
				dm.btn[i].classList.remove('is-active');
				dm.btn[i].setAttribute('aria-label', 'メニューを開く');
				if (!ISCL.isDesktop) {
					dm.btn[i].setAttribute('aria-expanded', false);
				}
			}
		},
		btnEnd: function(e) {
			if (e.propertyName === 'opacity') {
				this.classList.remove('is-anim');
			}
		},
		menuEnd: function(e) {
			if (e.propertyName === 'opacity' && e.target.nextElementSibling === null) {
				this.classList.remove('is-anim');
			}
		}
	};
	
	/**
	 * .anc[href^="#"] をクリックでスムーススクロール
	 * as.toScroll('top');
	 -------------------------------------------------- */
	function anchorScroll() {
		if (document.querySelector('.anc') !== null || document.querySelector('.js-anc') !== null || location.hash) {
			//console.log('-----> anchorScroll');
			as.constructor();
		}
	}
	const as = {
		constructor: function() {
			// URL に hash があったらスクロール
			if (location.hash) {
				window.scrollTo(0,0);
				setTimeout(this.landingScroll, 60);
			}
			
			this.SPF = 1000 / 60;
			this.duration = 800;
			this.scPad = 0;
			this.hash = null;
			this.onResize();
			this.cancelScroll(this);
			
			const anchor = document.querySelectorAll('.anc[href^="#"], .js-anc[href^="#"]');
			for (let i = 0, len = anchor.length; i < len; i++) {
				anchor[i].addEventListener('click', this.onClick);
			}
		},
		landingScroll: function() {
			//window.scrollTo(0,0);
			as.toScroll(location.hash.slice(1));
		},
		onClick: function(e) {
			e.preventDefault();
			const targetId = this.closest('[href]').getAttribute('href');
			as.toScroll(targetId.slice(1));
		},
		onResize: function() {
			this.scBtm = document.body.offsetHeight - window.innerHeight;
			this.scMax = document.body.clientHeight - window.innerHeight;
			if (document.querySelector('.l-header') !== null) {
				this.scPad = document.getElementsByClassName('l-header')[0].clientHeight - 1;
			}
		},
		toScroll: function(targetId) {
			if (targetId !== 'top' && document.getElementById(targetId) === null) return;
			//history.replaceState(null, null, './#' + targetId);
			
			// ドロワーメニューが開いていたら閉じる
			if (dm.isOpened) dm.closeMenu();
			
			this.startPos = window.pageYOffset;
			this.currentPos = this.startPos;
			this.elapsedTime = 0;
			this.goalPos = (targetId !== 'top') ? (document.getElementById(targetId).getBoundingClientRect().top + window.pageYOffset - this.scPad) : 0;
			
			if (this.goalPos >= this.scMax) this.goalPos = this.scMax;
			
			this.valueInChange = this.goalPos - this.startPos;
			this.doScroll();
			this.hash = '#' + targetId;
		},
		doScroll: function() {
			/* MEMO: history.replaceState だと :target が反映されないので location.href を使う */
			if (as.hash !== '#top') {
				if (location.hash !== as.hash && as.hash !== null) location.hash = as.hash;
				//if (location.hash !== as.hash && as.hash !== null) {
				//	history.replaceState(null, null, './' + as.hash)
				//}
			} else {
				if (as.hash !== null) location.hash = '';
				//history.replaceState(null, null, './');
			}
			
			const elapsedTimeRate = as.elapsedTime / as.duration;
			const valueChangeRate = as.easing(elapsedTimeRate);
			const changeYOffset = as.valueInChange * valueChangeRate;
			
			as.currentPos = as.startPos + changeYOffset;
			
			if (as.elapsedTime >= as.duration) {
				as.currentPos = as.goalPos;
				clearTimeout(as.timer);
				return;
			} else {
				as.elapsedTime += as.SPF;
				as.timer = setTimeout(as.doScroll, as.SPF);
			}
			window.scrollTo(0, as.currentPos);
		},
		cancelScroll: function(t) {
			let count = 0;
			if (ISCL.isTouch) {
				window.addEventListener('touchmove', function() {
					clearTimeout(t.timer);
				});
			} else {
				this.wheel = function() {
					clearTimeout(t.timer);
				}
				if (window.addEventListener) { window.addEventListener('DOMMouseScroll', this.wheel, false); }
				window.onmousewheel = document.onmousewheel = this.wheel;
			}
		},
		/* easeOutQuart ( https://easings.net/ ) */
		easing: function(x) {
			return 1 - Math.pow(1 - x, 4);
		}
	};
	
	/**
	 * モーダルコンテンツの中身を設置する
	 * 読み込みが必要なモーダルがあったら先に読み込んどく
	 * コンテンツに画像があるかもしれないので setInview はその後で実行
	 * data-type: json || html || text
	 * data-url: 読み込むファイルへのパス
	 -------------------------------------------------- */
	function setupModalContents() {
		if (document.querySelector('.js-modal[data-url]') !== null) {
			//console.log('-----> setupModalContents');
			smc.constructor();
		} else {
			smc.endFnc();
		}
	}
	const smc = {
		constructor: function() {
			this.isocalPath = '/nutrition/product/isocal/';
			const elms = document.getElementsByClassName('js-modal');
			for (let i = elms.length; i--;) {
				this.loadContents(elms[i], elms[i].id);
			}
		},
		endFnc: function() {
			modalContentsUi();
			setInview();
			anchorScroll();
		},
		loadContents: function(elm, id) {
			this.contentsWrap = elm.getElementsByClassName('modal_contents')[0];
			switch(id) {
				case 'purchase':
					smc.curProduct = null;
					doAjax(elm.dataset['url'], this.setupPurchase, elm.dataset['type']);
					break;
				default:
					doAjax(elm.dataset['url'], this.setupModal, elm.dataset['type']);
			}
		},
		/* html / text の場合はそのまま挿入 */
		setupModal: function(data) {
			smc.contentsWrap.innerHTML = data;
			smc.endFnc();
		},
		/* purchase.json の場合は一旦 data 保持 */
		setupPurchase: function(data) {
			smc.purchaseData = data;
			smc.endFnc();
		},
		// ボタンクリックするたびにコンテンツ生成
		createPurchase: function(id) {
			let contents = '';
			const data = smc.purchaseData[id];
			for (let i in data) {
				//console.log(this.isocalPath);
				contents += '<section class="purchase_section -' + id + '">';
				contents += '<h2 class="title">' + data[i].title + '</h2>';
				contents += '<figure class="photo"><img src="' + this.isocalPath + data[i].photo.src + '" alt="" width="' + data[i].photo.width + '" height="' + data[i].photo.height + '"></figure>';
				contents += this.createLinks(data[i].links);
				contents += '</section>';
			}
			smc.contentsWrap.innerHTML = contents;
			//return contents;
		},
		createLinks: function(links) {
			let buttons = '<ul class="c-shoplist">';
			for (let i in links) {
				if (links[i].status !== 'hidden') {
					buttons += '<li><a';
					if (links[i].status !== 'hold') {
						buttons += ' href="' + links[i].url + '" rel="noopener" target="_blank"';
					}
					buttons += ' class="button -' + links[i].id + '">' + links[i].title;
					buttons += '</a></li>';
				}
			}
			buttons += '</ul>';
			return buttons;
		}
	};
	
	/**
	 * モーダルコンテンツ UI 実装
	 * .js-modalTrigger クリックで .js-modal を展開
	 -------------------------------------------------- */
	function modalContentsUi() {
		if (document.querySelector('.js-modalTrigger') !== null) mcu.constructor();
	}
	const mcu = {
		constructor: function() {
			//console.log('-----> modalContentsUi');
			this.modalData = {};
			
			// data-modal 属性がある .js-modalTrigger にクリックイベントを実装する
			const triggers = document.getElementsByClassName('js-modalTrigger');
			for (let i = triggers.length; i--;) {
				this.setupModalUi(triggers[i]);
			}
			
			// id 属性がある .js-modal をモーダルにする
			const modalElms = document.getElementsByClassName('js-modal');
			for (let i = modalElms.length; i--;) {
				if (modalElms[i].id !== null) {
					this.setupContents(modalElms[i]);
				}
			}
			//console.log(this.modalData);
		},
		// モーダル実装 (開く時は close が最後、閉じる時は overlay が最後)
		setupContents: function(elm) {
			this.modalData[elm.id].contents = elm;
			
			elm.addEventListener('transitionend', this.animEnd);
			elm.setAttribute('aria-hidden', true);
		},
		animEnd: function(e) {
			mcu.isOpen ? mcu.openEnd(this, e) : mcu.closeEnd(this, e);
		},
		openEnd: function(t, e) {
			if (e.target.className.indexOf('modal_close') !== -1) {
				if (e.propertyName === 'opacity') t.classList.remove('is-anim');
			}
		},
		closeEnd: function(t, e) {
			if (e.target.className.indexOf('modal_overlay') !== -1) {
				if (e.propertyName === 'opacity') t.classList.remove('is-anim');
			}
		},
		// 展開ボタン実装
		setupModalUi: function(trigger) {
			
			if (trigger.dataset['modal'] !== undefined) {
				this.modalData[ trigger.dataset['modal'] ] = {};
				this.modalData[ trigger.dataset['modal'] ].button = trigger;
				
				trigger.addEventListener('click', this.openModal);
				
				trigger.setAttribute('aria-controls', trigger.dataset['modal']);
				trigger.setAttribute('aria-expanded', false);
				trigger.setAttribute('aria-label', '開く');
			} else {
				trigger.addEventListener('click', this.closeModal);
				
				trigger.setAttribute('aria-label', '閉じる');
				const id = trigger.closest('.js-modal').id;
				trigger.dataset['modal'] = id;
			}
		},
		openModal: function(e) {
			mcu.isOpen = 1;
			mcu.yOffset = window.pageYOffset;
			document.body.classList.add('is-fixed');
			document.body.style.marginTop = -mcu.yOffset + 'px';
			const dataModal = this.dataset['modal'];
			const targetModal = dataModal.indexOf('#') > 0 ? dataModal.split('#')[0] : dataModal;
			
			switch(targetModal) {
				// targetModal が purchase だったらコンテンツ書き換えてから開く
				case 'purchase':
					const targetId = dataModal.indexOf('#') > 0 ? dataModal.split('#')[1] : dataModal;
					// すでに入っている商品と同じなら書き換えない
					//console.log(smc.curProduct !== targetId);
					if (smc.curProduct !== targetId) {
						smc.createPurchase(targetId);
						smc.curProduct = targetId;
					}
					break;
				// それ以外はそのまま開く (基本ハッシュなし)
				default: break;
			}
			
			mcu.currentOpen = dataModal;
			
			const target = mcu.modalData[targetModal].contents;
			const button = mcu.modalData[mcu.currentOpen].button;
			target.classList.add('is-anim');
			target.classList.add('is-active');
			target.setAttribute('aria-hidden', false);
			button.setAttribute('aria-expanded', true);
		},
		closeModal: function(e) {
			mcu.isOpen = 0;
			document.body.classList.remove('is-fixed');
			document.body.removeAttribute('style');
			window.scrollTo(0, mcu.yOffset);
			
			const id = this.dataset['modal'];
			
			const target = mcu.modalData[id].contents;
			const button = mcu.modalData[mcu.currentOpen].button;
			
			target.classList.add('is-anim');
			target.classList.remove('is-active');
			target.setAttribute('aria-hidden', true);
			button.setAttribute('aria-expanded', false);
		}
	};
	
	/**
	 * Pulldown UI 実装
	 * <button class="js-pullToggle" data-pull="{ID}">
	 * <div class="js-pullContents" data-pull="{ID}">
	 -------------------------------------------------- */
	function pulldownUi() {
		if (document.querySelector('.js-pullContents') !== null) {
			pd.constructor();
			ISCL.pd = pd;
		}
	}
	ISCL.pulldownUi = pulldownUi;
	const pd = {
		constructor: function() {
			//console.log('-----> pulldownUi');
			this.pullData = {};
			const toggle = document.getElementsByClassName('js-pullToggle');
			
			let property, contents;
			for (let i = 0, len = toggle.length; i < len; i++) {
				property = toggle[i].dataset['pull'];
				contents = document.querySelector('.js-pullContents[data-pull="' + property + '"]');
				
				contents.id = property;
				contents.setAttribute('aria-hidden', true);
				toggle[i].setAttribute('aria-expanded', false);
				toggle[i].setAttribute('aria-controls', property);
				
				if (this.pullData[property] === undefined) {
					this.pullData[property] = {
						isOpened: false,
						toggle: [],
						contents: contents,
						contentsHeight: contents.clientHeight
					};
					this.pullData[property].toggle.push(toggle[i]);
					contents.style.height = 0;
				} else {
					this.pullData[property].toggle.push(toggle[i]);
				}
				
				toggle[i].addEventListener('click', this.onClick);
			}
			//console.log(this.pullData);
		},
		refresh: function() {
			//console.log('-----> pd.refresh', this.pullData);
			for (let i in this.pullData) {
				if (this.pullData[i].isOpened) {
					this.pullData[i].contentsHeight = this.pullData[i].contents.clientHeight;
				} else {
					this.pullData[i].contents.removeAttribute('style');
					this.pullData[i].contentsHeight = this.pullData[i].contents.clientHeight;
					this.pullData[i].contents.style.height = 0;
				}
			}
		},
		onClick: function() {
			const property = this.dataset['pull'];
			const data = pd.pullData[property];
			!data.isOpened ? pd.pullOpen(data) : pd.pullClose(data);
			for (let i = data.toggle.length; i--;) {
				if (data.toggle[i].className.indexOf('-close') < 0) {
					data.toggle[i].classList.add('is-anim');
					data.toggle[i].classList.add('is-active');
					data.toggle[i].setAttribute('aria-expanded', true);
					data.toggle[i].addEventListener('transitionend', pd.toggleEnd);
				}
			}
		},
		pullOpen: function(data) {
			data.contents.classList.add('is-anim');
			data.contents.setAttribute('aria-hidden', false);
			data.contents.addEventListener('transitionend', pd.openEnd);
			data.contents.style.height = data.contentsHeight + 'px';
		},
		toggleEnd: function(e) {
			if (e.target !== this) {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', pd.toggleEnd);
			}
		},
		openEnd: function(e) {
			if (e.propertyName === 'height') {
				pd.pullData[ this.dataset['pull'] ].isOpened = true;
				this.classList.add('is-active');
				this.classList.remove('is-anim');
				this.removeAttribute('style');
				this.removeEventListener('transitionend', pd.openEnd);
			
				// プルコンテンツの中にアンカーリンクがあったら as.onResize
				if (this.querySelector('.js-anc') !== null) as.onResize();
			}
		},
		pullClose: function(data) {
			data.contents.style.height = data.contentsHeight + 'px';
			setTimeout(function() {
				data.isOpened = false;
				data.contents.classList.add('is-anim');
				data.contents.classList.remove('is-active');
				data.contents.setAttribute('aria-hidden', true);
				for (let i = data.toggle.length; i--;) {
					data.toggle[i].classList.remove('is-active');
					data.toggle[i].setAttribute('aria-expanded', false);
				}
				data.contents.style.height = 0;
				data.contents.addEventListener('transitionend', pd.closeEnd);
			}, 60);
		},
		closeEnd: function(e) {
			if (e.propertyName === 'height') {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', pd.closeEnd);
			}
		}
	};
	
	/**
	 * in-view
	 * -------------------------------------------------- */
	function setInview() {
		//console.log('-----> setInview');
		iv.constructor();
	}
	const iv = {
		constructor: function() {
			if (document.querySelector('.js-inview') !== null) iv.basic();
			if (document.querySelector('img[data-src]') !== null) {
				iv.lazySetup();
			} else {
				pulldownUi();
			}
			inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });
		},
		basic: function() {
			inView('.js-inview').on('enter', this.doInview);
		},
		doInview: function(el) {
			if (!el.isInview) {
				el.isInview = 1;
				el.classList.add('is-anim');
				el.classList.add('is-inview');
				el.addEventListener('transitionend', iv.animEnd);
			}
		},
		animEnd: function() {
			this.classList.remove('is-anim');
			this.classList.remove('js-inview');
			this.removeEventListener('transitionend', iv.animEnd);
		},
		// lazyLoader & inview
		lazySetup: function() {
			let cls, w, h;
			const imgs = document.querySelectorAll('img[data-src]');
			for (let i = 0, len = imgs.length; i < len; i++) {
				cls = imgs[i].getAttribute('class') ? ' ' + imgs[i].getAttribute('class') : '';
				w = imgs[i].getAttribute('width');
				h = imgs[i].getAttribute('height');
				imgs[i].src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 ' + w + ' ' + h + '%22%3E%3C/svg%3E';
			}
			this.lazy();
			pulldownUi();
		},
		lazy: function() {
			inView('img[data-src]').on('enter', this.doLazy);
		},
		doLazy: function(el) {
			if (!el.isInview) {
				imagesLoaded(el, iv.imageLoaded);
				el.src = el.dataset['src'];
				el.isInview = 1;
			}
		},
		imageLoaded: function() {
			this.elements[0].classList.add('is-anim');
			this.elements[0].classList.add('is-loaded');
			this.elements[0].addEventListener('transitionend', iv.loadedEnd);
		},
		loadedEnd: function() {
			this.classList.remove('is-anim');
			this.removeAttribute('data-src');
			this.removeEventListener('transitionend', iv.loadedEnd);
		}
	};
	
	/**
	 * YouTube API
	 -------------------------------------------------- */
	function setupYouTube() {
		if (document.querySelector('.js-yt') !== null) yt.constructor();
	}
	ISCL.setupYouTube = setupYouTube;
	const yt = {
		constructor: function() {
			//console.log('-----> setupYouTube');
			this.firstElm = document.getElementsByClassName('js-yt')[0];
			this.elmTop = parseInt(this.firstElm.getBoundingClientRect().top + window.pageYOffset);
			window.addEventListener('scroll', this.onScroll, false);
		},
		onScroll: function() {
			if (window.pageYOffset + window.innerHeight > yt.elmTop) yt.ready();
			if (yt.elmTop !== parseInt(yt.firstElm.getBoundingClientRect().top + window.pageYOffset)) {
				yt.elmTop = parseInt(yt.firstElm.getBoundingClientRect().top + window.pageYOffset);
			}
		},
		ready: function() {
			window.removeEventListener('scroll', yt.onScroll, false);
			delete yt.elmTop;
			yt.player = {};
			yt.playerVars = { controls: 0, modestbranding: 1, enablejsapi: 1, playsinline: 1, rel: 0 };
			yt.loadAPI();
		},
		loadAPI: function() {
			let tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			global.onYouTubeIframeAPIReady = function() { yt.init(); }
		},
		init: function() {
			const ytElms = document.getElementsByClassName('js-yt');
			let id, ytid, w, h;
			for (let i = 0, len = ytElms.length; i < len; i++) {
				//console.dir(ytElms[i]);
				id = 'player-' + i;
				ytid = ytElms[i].dataset['ytid'];
				w = ytElms[i].getAttribute('width');
				h = ytElms[i].getAttribute('height');
				ytElms[i].setAttribute('id', id);
				yt.setup(id, ytid, w, h);
				this.setUI(ytElms[i].parentNode.parentNode, id);
			}
		},
		setUI: function(wrap, id) {
			//console.log(wrap);
			const poster = wrap.getElementsByClassName('poster')[0];
			poster.dataset['player'] = id;
			poster.addEventListener('click', this.onPlay);
		},
		setup: function(id, ytid, w, h) {
			this.player[id] = new YT.Player(id, {
				width: w, height: h, videoId: ytid,
				playerVars: this.playerVars,
				events: {
					'onReady': yt.onPlayerReady,
					'onStateChange': yt.onPlayerStateChange
				}
			});
		},
		onPlay: function() {
			if (yt.player === undefined) return;
			//console.log('onPlay');
			const player = yt.player[this.dataset['player']];
			if (player.getPlayerState() !== 1) {
				this.parentNode.classList.add('is-playing');
				player.playVideo();
			} else {
				player.pauseVideo();
			}
		},
		onPlayerReady: function(e) {
			//console.log('onPlayerReady', e);
		},
		onPlayerStateChange: function(e) {
			//console.log('onPlayerStateChange', e);
			if (e.data === 0 || e.data === 2) {
				e.target.getIframe().parentNode.parentNode.classList.remove('is-playing');
			}
		}
	};
	
	/**
	 * fetch が使えたら fetch、使えなかったら xhr で Ajax する
	 * (ISCL.)doAjax(request, function() {}, 'text');
	 * fetchAjax(request, function() {}, 'json');
	 * xhrAjax(request, function() {}, 'blob');
	 * -------------------------------------------------- */
	function doAjax(req, fn, format) {
		if (self.fetch) {
			fetchAjax(req, fn, format)
		} else {
			xhrAjax(req, fn, format)
		}
	}
	ISCL.doAjax = doAjax;
	function fetchAjax(req, fn, format) {
		//console.log('-----> fetchAjax');
		fetch(req)
		.then(function(response) {
			return new Promise(function(resolve, reject) {
				return response[format]()
				.then(function(data) {
					return resolve(data);
				}, function(error) {
					return reject(error);
				});
			});
		})
		.then(function(data) {
			//console.log('Success:', JSON.stringify(data))
			fn(data);
		}, function(error) {
			console.log('error ----->'.concat(error));
		});
	};
	function xhrAjax(req, fn, format) {
		//console.log('-----> xhrAjax');
		const xhr = new XMLHttpRequest();
		if (format !== 'json') {
			xhr.responseType = format;
		}
		xhr.addEventListener('progress', function(e) {
			const rate = e.loaded / (e.total == 0 ? e.loaded : e.total);
			//console.log(e, rate);
		});
		xhr.addEventListener('load', function(e) {
			if (xhr.readyState === 4) {
				if (xhr.status == 200 || xhr.status == 304) {
					let data = e.target.response;
					if (format === 'json') data = JSON.parse(data);
					fn(data);
				}
			}
		});
		xhr.open('GET', req);
		xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
		xhr.send();
	};
	
	/**
	 * common
	 * -------------------------------------------------- */
	const resized = function(fn) {
		if (resized.timer !== false) clearTimeout(resized.timer);
		resized.timer = setTimeout(fn, 200);
	};
	function breakPointLintener() {
		const breakPoint = window.matchMedia('(min-width: 768px)');
		breakPoint.addListener(function(e) { ISCL.isDesktop = e.matches; });
	}
	breakPointLintener();
	function addFnc(fns) {
		for (let i = 0, len = fns.length; i < len; i++) {
			if (typeof fns[i] === 'function') fns[i]();
		}
	}
	ISCL.addFnc = addFnc;
	(function common() {
		const doc = document.documentElement, ua = navigator.userAgent.toLowerCase();
		ISCL.isIE = ( ua.indexOf('msie') != -1 || ua.indexOf('trident') != -1 );
		ISCL.isTouch = !!( 'ontouchstart' in window || (navigator.pointerEnabled && navigator.maxTouchPoints > 0) );
		ISCL.isDesktop = window.matchMedia('(min-width: 768px)').matches;
		ISCL.isWindows = ua.indexOf('windows nt') !== -1;
		if (ISCL.isWindows) doc.classList.add('isWindows');
		if (ISCL.isTouch) doc.classList.add('isTouch');
		if (ISCL.isIE) doc.classList.add('isIE');
		if (window.innerWidth !== doc.clientWidth) doc.classList.add('hasScrollbar');
	})();
	
	// Element.closest() Polyfill
	Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(e){var t=this;do{if(Element.prototype.matches.call(t,e))return t;t=t.parentElement||t.parentNode}while(null!==t&&1===t.nodeType);return null});
})((this || 0).self || global);